/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClickLinkUser
 */
export interface ClickLinkUser {
    /**
     * 
     * @type {string}
     * @memberof ClickLinkUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClickLinkUser
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof ClickLinkUser
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClickLinkUser
     */
    displayName: string;
}

export function ClickLinkUserFromJSON(json: any): ClickLinkUser {
    return ClickLinkUserFromJSONTyped(json, false);
}

export function ClickLinkUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClickLinkUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'username': json['username'],
        'email': json['email'],
        'displayName': json['display_name'],
    };
}

export function ClickLinkUserToJSON(value?: ClickLinkUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'username': value.username,
        'email': value.email,
        'display_name': value.displayName,
    };
}


